import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MaterialsTab from "./MaterialsTab/MaterialsTab";
import UnitsTab from "./UnitsTap/UnitsTab";

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`materials-tabpanel-${index}`} aria-labelledby={`materials-tab-${index}`}>
      {value === index && <Box sx={{ p: 2 }}><Typography component="div">{children}</Typography></Box>}
    </div>
  );
}

const MaterialsMainPage = () => {
  const [value, setValue] = useState(0);

  return (
    <Paper sx={{ p: 2 }}>
      <Tabs value={value} onChange={(e, v) => setValue(v)} variant="fullWidth" textColor="primary" indicatorColor="primary">
        <Tab label="الخامات" id="materials-tab-0" aria-controls="materials-tabpanel-0" />
        <Tab label="وحدات القياس" id="materials-tab-1" aria-controls="materials-tabpanel-1" />
      </Tabs>

      <TabPanel value={value} index={0}>
        <MaterialsTab />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <UnitsTab />
      </TabPanel>
    </Paper>
  );
};

export default MaterialsMainPage;
